export default __webpack_public_path__ + "static/media/sprite-emma-1-2.8f09403f.png";